import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {TextField, InputLabel, createStyles, Theme as AugmentedTheme} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';

interface IOneLine {
    field: CustomInputMappingField,
    value: string,
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    field: {
        width: '100%',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '.2px',
        lineHeight: '20px',
        color: '#202124',

        "&::placeholder": {
            fontSize: '14px',
        },
    },
      //@ts-ignore
      inputLabel: theme.inputLabel,
      //@ts-ignore
      requiredLabel: theme.requiredLabel,
      //@ts-ignore
      requiredField: theme.requiredField,
}))


export default function OneLineField({ field, value, onChangeHandler,isRtl }: IOneLine) {
    const classes = useStyles();
    const [isMultiline, setIsMultiLine] = useState<boolean>(false);
    const [inputType, setInputType] = useState<string>('text');
    const [datetimeLocalProps, setDatetimeLocalProps] = useState<object>({});

    useEffect(() =>{
        if(field.type === 'paragraph') {
            setIsMultiLine(true);
        }

        if(field.type === 'dateTime') {
            setInputType('datetime-local')
        } else {
            setInputType(field.type)
        }
    }, [field])

    useEffect(() => {
        if(inputType === 'datetime-local') {
            setDatetimeLocalProps({
                min:"1901-06-01T08:30",
                max:"2200-06-30T16:30"
            })
        }
    }, [inputType])

    const isDate = field.type === 'date' || field.type === 'dateTime'
    const isEmpty = !value || value.trim() === ''
    const showRequired = field.required && isEmpty
    
    return(
        <>
                <InputLabel
               style={{ 
                direction: isRtl ? 'rtl' : 'ltr',
                textAlign: isRtl ? 'right' : 'left' 
            }} 
             htmlFor={field.sourceField} 
             className={showRequired ? classes.requiredLabel : classes.inputLabel}
             >{field.fieldName}</InputLabel>
              <TextField  
                    style={{ 
                        direction: isRtl ? 'rtl' : 'ltr',
                        textAlign: isRtl ? 'right' : 'left' 
                    }} 
                  multiline={isMultiline} 
                  value={value} 
                  id={field.sourceField} 
                  className={`${classes.field} ${showRequired ? classes.requiredField : ''}`} 
                  placeholder={field.fieldName} 
                  onChange={onChangeHandler} 
                  name={field.fieldName} 
                  type={inputType} 
                  required={field.required}                    
                  inputProps={{...datetimeLocalProps, dir: isRtl ? 'rtl' : 'ltr', style: {width: isDate && isRtl ? 'unset' : '100%'}}}
              />    
              </>
    )
}